import React from 'react';
import logoSGR from '../../assets/SGRLock.png';
import logoSwint from '../../assets/swintLogo.svg';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import { Container, Content } from './styles';

const GeolocationDenied: React.FC = () => {
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.pages.geolocationDenied);
  const { tp: tpLogos } = translationPage(tr => tr.components.logos);

  return (
    <Container>
      <img src={logoSGR} alt={tpLogos('sgrLoc')} />
      <Content>
        <img src={logoSwint} alt={tpLogos('swint')} />
        <p>{tp('firstParagraph')}</p>
        <p>
          {tp('secondParagraph.part1')}{' '}
          <span>{tp('secondParagraph.siteSettings')}</span>
          {tp('secondParagraph.part2')}{' '}
          <span>{tp('secondParagraph.permissions')}</span>
          {tp('secondParagraph.part3')}{' '}
          <span>{tp('secondParagraph.location')}</span>{' '}
          {tp('secondParagraph.part4')}{' '}
          <span>{tp('secondParagraph.allow')}</span>
        </p>

        <a href="/">{tp('retry')}</a>
      </Content>
    </Container>
  );
};

export default GeolocationDenied;
